export default "__VITE_ASSET__CUlRO2S3__"